import { trackPageView } from './rudderstack'

export default () => {
  trackPageView({ isClientSideNavigation: true })
}
